import { FormattedMessage } from 'react-intl'

import Button from 'app/components/base/Button'
import Divider from 'app/components/base/Divider'
import Stack from 'app/components/base/Stack'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface PhoneEmailButtonGroupProps {
  handleChange: () => void
  isPhone: boolean
}

const PhoneEmailButtonGroup: RFC<PhoneEmailButtonGroupProps> = ({
  handleChange,
  isPhone
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'border.main',
        borderRadius: IS_NATIVE_APP ? 8 : 1
      }}
    >
      <Button
        variant="text"
        size="small"
        fullWidth
        {...(isPhone && { onClick: handleChange })}
        sx={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          backgroundColor: !isPhone
            ? 'background.lightGreen'
            : 'background.paper',
          flex: 1
        }}
      >
        <FormattedMessage defaultMessage="Email" />
      </Button>

      <Divider
        orientation="vertical"
        style={{ height: 36, borderColor: 'border.main', width: 1 }}
      />

      <Button
        variant="text"
        size="small"
        fullWidth
        {...(!isPhone && { onClick: handleChange })}
        sx={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          backgroundColor: isPhone
            ? 'background.lightGreen'
            : 'background.paper',
          flex: 1
        }}
      >
        <FormattedMessage defaultMessage="Phone Number" />
      </Button>
    </Stack>
  )
}

export default PhoneEmailButtonGroup
